import { Component, Input, OnInit } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { Location as MapLocation } from 'app/graphql/types';

@Component({
  selector: 'app-google-maps',
  templateUrl: './google-maps.component.html',
  styleUrls: ['./google-maps.component.scss'],
})
export class GoogleMapsComponent implements OnInit {
  @Input() location: MapLocation;
  zoom = 13;
  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions;
  markerOptions: google.maps.marker.AdvancedMarkerElementOptions;

  ngOnInit() {
    this.center = {
      lat: this.location.geolocation.latitude,
      lng: this.location.geolocation.longitude,
    };
    this.options = {
      mapId: 'DEMO_MAP_ID',
      center: { lat: this.location.geolocation.latitude, lng: this.location.geolocation.longitude },
      zoom: 13,
    };
    this.markerOptions = {
      title: 'Plaza Constitución',
      position: {
        lat: this.location.geolocation.latitude,
        lng: this.location.geolocation.longitude,
      },
    };
  }

  onMapReady(map: google.maps.Map): void {
    // Crear un contenedor HTML personalizado para el marcador avanzado
    if (google.maps.marker && google.maps.marker.AdvancedMarkerElement) {
      const markerDiv = document.createElement('div');
      markerDiv.style.backgroundColor = 'blue';
      markerDiv.style.color = 'white';
      markerDiv.style.padding = '10px';
      markerDiv.style.borderRadius = '5px';
      markerDiv.innerText = 'Marcador Avanzado';

      const advancedMarker = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: this.center,
        content: markerDiv,
      });
    } else {
      console.error(
        'AdvancedMarkerElement no está disponible. Asegúrate de estar usando la versión correcta de la API.'
      );
    }
  }
  open_maps() {
    let url =
      'http://maps.google.com/maps?z=12&t=m&q=loc:' +
      this.location.geolocation.latitude +
      ',' +
      this.location.geolocation.longitude;
    window.open(url, '_new');
  }
  ngOnDestroy() {}
}
